import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { toast } from 'react-toastify'


export const getTimetable = createAsyncThunk('timetable/getTimetable', async (filterData) => {
  try {
    let url = API_ROUTES.TIMETABLE.GET_TIMETABLE

    let query = ''
    for (const key in filterData) {
      if (filterData[key]) {
        query += `${key}=${filterData[key]}&`
      }
    }
    query = query.slice(0, -1)
    const response = await apiClient.get(`${url}?${query}`)
   filterData?.filter && filterData.setOpen(false)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getTimetableCourse = createAsyncThunk('timetable/getTimetableCourse', async (batchId) => {
  try {
    const url = API_ROUTES.TIMETABLE.GET_TIMETABLE_COURSE(batchId)
    const response = await apiClient.get(url)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createTimetable = createAsyncThunk(
  'timetable/createTimetable',
  async ({ data, setOpen, setSaveState, saveState }) => {
    try {
      const url = API_ROUTES.TIMETABLE.POST_TIMETABLE
      const response = await apiClient.post(url, data)
      if (response?.status) {
        setSaveState(!saveState)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
        setOpen(false)
      }
      // dispatch(getTimetable(filter))
    } catch (error) {
      console.error('builder function error:', error)
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error
    }
  },
)

export const editTimetable = createAsyncThunk(
  'timetable/editTimetable',
  async ({ data, timetableId, filter, setOpen, setSaveState }, { dispatch }) => {
    try {
      const response = await apiClient.put(`/timetable/${timetableId}`, data)
      if (response?.status) {
        setSaveState(true)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
        setOpen(false)
      }
      dispatch(getTimetable(filter))
      return response.data
    } catch (error) {
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const deleteTimetable = createAsyncThunk(
  'timetable/deleteTimetable',
  async ({ timetableId, filter, setOpen, setSaveState }, { dispatch }) => {
    try {
      const response = await apiClient.delete(`/timetable/${timetableId}`)
      if (response?.status) {
        setSaveState(true)
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
        setOpen(false)
      }
      dispatch(getTimetable(filter))
      return response.data
    } catch (error) {
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      console.error('builder function error:', error)
      throw error
    }
  },
)
